// =============================================================================
// features/sales/campaigns/CampaignsPage.tsx — Rota `/campanhas` (F35-S07,
// doc 26 §6.5).
//
// Gate de permissão + flag (mesmo padrão de
// features/sales/agenda/AgendaPage.tsx): `sales_campaigns:read` E
// `sales.campaigns.enabled`. Acesso direto à URL sem qualquer um dos dois
// mostra um estado PRÓPRIO desta página — nunca uma tela quebrada nem um
// redirect surpresa (F35-S07 DoD). O conteúdo real (CampaignsContent, que
// dispara as queries) só monta depois que os dois gates passam, para nunca
// disparar requisição fadada ao 403.
// =============================================================================

import * as React from 'react';

import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
import { useAuth } from '../../../lib/auth-store';

import { CampaignsContent } from './CampaignsContent';

const FLAG_KEY = 'sales.campaigns.enabled';
const READ_PERMISSION = 'sales_campaigns:read';

export function CampaignsPage(): React.JSX.Element {
  const { hasPermission } = useAuth();
  const { enabled: flagEnabled, isLoading: flagLoading } = useFeatureFlag(FLAG_KEY);

  const canRead = hasPermission(READ_PERMISSION);

  if (!canRead) {
    return (
      <div className="flex flex-col items-center justify-center py-16 gap-3 text-center">
        <p className="font-sans text-sm text-ink-3 max-w-xs">
          Você não tem acesso às campanhas comerciais. Fale com um administrador se precisar de
          acesso.
        </p>
      </div>
    );
  }

  if (flagLoading) {
    return (
      <div className="flex flex-col gap-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <div
            key={i}
            className="h-16 rounded-md animate-pulse"
            style={{ background: 'var(--surface-muted)' }}
            aria-hidden="true"
          />
        ))}
      </div>
    );
  }

  if (!flagEnabled) {
    return (
      <div
        className="flex items-start gap-3 px-4 py-3 rounded-sm border"
        style={{
          background: 'var(--warning-bg)',
          borderColor: 'var(--warning)',
          borderLeftWidth: 3,
        }}
        role="alert"
      >
        <div>
          <p className="font-sans text-sm font-semibold text-ink">Módulo desabilitado</p>
          <p className="font-sans text-xs text-ink-3 mt-0.5">
            A flag <code className="font-mono">{FLAG_KEY}</code> está desativada para esta
            organização.
          </p>
        </div>
      </div>
    );
  }

  return <CampaignsContent />;
}
